import React, { useRef, useState } from 'react';
import Gallery from './Gallery';
import { galleryData } from '../data/galleryData';

const Wine = () => {
  const galleryRef = useRef();
  const [showMore, setShowMore] = useState(false);

  const handleViewWine = () => {
    galleryRef.current?.openGallery(0);
  };

  const handleCelebration = () => {
    setShowMore(!showMore);
  };

  return (
    <section id="wine" className="section wine-section">
      <div className="section-header">
        <img src="/images/wine.png" alt="Wine" className="section-icon" />
        <h1>Vino</h1>
      </div>
      <p>
        Discover the rich world of <b>Wine!</b> From bold reds to crisp whites, from vintage champagnes to artisanal rosés, wine represents centuries of tradition, craftsmanship, and culture.
		Each bottle tells a story of terroir, passion, and the art of winemaking that brings people together around tables worldwide.
      </p>

	          {showMore && (
          <div className="extended-intro">
            <p>I have been making wine every season since I was a kid that got in the way.  I started to help as much as I can and as I grew so did the responsibilities. I learned more & more each year.</p>
            <p>Making wine in my family has been a tradition and a passion that has been passed down for many generations. Each generation has added in their own way something new to pass long to the next.</p>
          </div>
        )}

      <div className="cta-buttons">
        <button className="cta-btn primary" onClick={handleCelebration}>
          <i className="fas fa-wine-glass"></i>
          {showMore ? 'Less' : 'More About Wine'}
        </button>

        <button className="cta-btn secondary" onClick={handleViewWine}>
          <i className="fas fa-wine-glass-alt"></i>
          Make Me Wine
        </button>
      </div>
      
      <Gallery ref={galleryRef} images={galleryData.wine} sectionName="Wine is in our blood" maxDisplay={4} />
    </section>
  );
};

export default Wine;
